import Twilio from './Twilio';
import API from './API';
import Trigger from './Trigger';
import Session from './Session';
import Socket from './Socket';
import Helper from '../Models/Helper';
import {writable} from 'svelte/store';

// const content = {active: false, sid: false, duration: 0, formattedDuration: '00:00', events: [], participants: []};
const content = {
	call: {active: false, showActive: false, id: false, sid: false, name: false, duration: 0, formattedDuration: '00:00', dialPressed: [], events: [], participants: [], contact: {}, agent: {}},
	current: {showActive: false, stillActive: false, sid: false, name: false, events: [], participants: [], contact: {}, agent: {}},
	list: {incoming: [], active: [], all: []},
	listCall: false,
};
let durationTimeout = false
let conference = writable(content);

conference.get = async (id, loader = true) => {
	const response = await API.request('get', `conference/${id}`, {}, loader);
	if(response.success) {
		if(response.events) content.current.events = response.events;
		if(response.participants) content.current.participants = response.participants;
		if(response.sid) content.current.sid = response.sid;
		if(response.name) content.current.name = response.name;

		content.current.showActive = response?.active;
		conference.set(content);
	}
}

conference.getActive = () => {
	return content.call.active;
}

conference.incrementDuration = () => {
	content.call.duration++;
	content.call.formattedDuration = Helper.secondsToMinutes(content.call.duration);
	conference.set(content);
}

conference.setDurationCounter = () => {
	durationTimeout = setTimeout(() => {
		conference.incrementDuration();
		conference.setDurationCounter();
	}, 1000);
}

conference.setData = (id, sid, name, duration) => {
	if(id) content.call.id = id;
	if(sid) content.call.sid = sid;
	if(name) content.call.name = name;
	if(duration) content.call.duration = duration;
	conference.set(content);
}

conference.setActive = (active = true) => {
	clearTimeout(durationTimeout);
	if(active) {
		content.call.active = true;
		content.call.duration = 0;
		if(!content.current.showActive && !content.call.showActive) {
			content.call.events = [];
			content.call.participants = [];
		}
		conference.set(content);
		conference.setDurationCounter();
	} else {
		content.call.active = false;
		conference.set(content);
	}
};

conference.setContact = (contact, timeline, show) => {
	let type = show ? 'current' : 'call';
	if(contact)
		content[type].contact.details = contact;

	if(timeline)
		content[type].contact.timeline = timeline;

	conference.set(content);
}

conference.setAgent = (agent, timeline, show) => {
	let type = show ? 'current' : 'call';
	if(agent)
		content[type].agent.details = agent;

	if(timeline)
		content[type].agent.timeline = timeline;

	conference.set(content);
}

conference.clearEvents = () => {
	content.events = [];
	conference.set(content);
}

conference.setEvents = (data) => {
	if(content.call.sid == data.conferenceSid) {
		content.call.events = data.events;
		conference.set(content);
	}
}

conference.setParticipants = (data) => {
	if(content.call.sid == data.conferenceSid) {
		content.call.participants = data.participants;
		conference.set(content);
		Trigger.event('participants');
	}
}

conference.setList = (list) => {
	content.list = list;
	conference.set(content);
	for(const item of list.all) {
		if(item.twilio == content.current.sid) {
			content.current.showActive = item.status == 'started' || item.status == 'ringing';
			content.current.events = item.events;
			content.current.participants = item.participants;
		}

		if(content.call.id == item.id) {
			if(item.status == 'started') content.call.showActive = true;
			else content.call.showActive = false;
		}
	}
}

conference.disconnect = async () => {
	await Twilio.disconnect();
}

conference.dial = (dial) => {
	content.call.dialPressed.push(dial);
	conference.set(content);
	Twilio.dial(dial)
}

// participants

conference.muteParticipant = async (participantSid, mute) => {
	const sid = content.call.sid;
	let success = false;
	if(participantSid) {
		const response = await API.request('post', `conference/${sid}/participant/${participantSid}/mute`, {mute}, false)
		success = response.success;
	}
	return success;
}

conference.holdParticipant = async (participantSid, hold) => {
	const sid = content.call.sid;
	let success = false;
	if(participantSid) {
		const response = await API.request('post', `conference/${sid}/participant/${participantSid}/hold`, {hold}, false)
		success = response.success;
	}
	return success;
}

conference.hangupParticipant = async (participantSid, agentId) => {
	const sid = content.call.sid;
	let success = false;
	if(participantSid || agentId) {
		const response = await API.request('post', `conference/${sid}/participant/${participantSid}/hangup`, {agentId, conferenceId: content.call.id}, false)
		success = response.success;
	}
	return success;
}

conference.forward = async (conferenceId, toAgentId) => {
	const agentId = Session.getId();
	Socket.send('post', '/conference/forward', {id: conferenceId, toAgentId, fromAgentId: agentId});
}

conference.answer = async (conferenceName, contactId) => {
	const agentId = Session.getId();
	Socket.send('post', '/conference/answered', {conferenceName, contactId, agentId});
}


export default conference;